import "../src/assets/css/App.css";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import Facebook from "./pagefb/facebook";
import IframePage from "./pagefb/iframe";
import Insta from "./pagefb/insta";
import Twitter from "./pagefb/twitter";
import Messenger from "./pagefb/messenger";
import React, { useEffect, useState } from "react";
import "./plugins/axios";

function App() {
  // let [url, SetUrl] = useState("");
  // useEffect(() => {
  //   const queryparam = window.location.search;
  //   const url_params = new URLSearchParams(queryparam);
  //   const q = url_params.get("q");
  //   SetUrl(q);
  // }, []);
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/fbMbl/:url" element={<Facebook />}></Route>
          <Route path="/iNsta/:url" element={<Insta />}></Route>
          <Route path="/Msg/:url" element={<Messenger />}></Route>
          <Route path="/TwT/:url" element={<Twitter />}></Route>
          <Route path="/getpage/:id" element={<IframePage />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
